import React, { useState, useEffect } from "react";
import CustomInput from "../../../Components/Common/CustomInput";
import CustomButton from "../../../Components/Common/CustomButton";
// import { useDispatch } from "react-redux";
// import { createProfile, editProfile } from "../../../redux/users/userSlice";
// import Cookies from "js-cookie";
import Commontexfiled from "../../../Components/Common/Commontextfiled";
import { editProfile } from "../../../redux/users/userSlice";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
const UserWork = ({
  setActiveTab,
  setFormData,
  WorkDataStateForm,
  WorkDataState,
  formData,
  ProId,
  handleUserWorkSubmit,
  userType,
}) => {
  const [formValues, setFormValues] = useState(WorkDataState || {});
  const [invalidFields, setInvalidFields] = useState({});
  const dispatch = useDispatch();
  const { singleUser ,isLoading} = useSelector((state) => state.users);

  useEffect(() => {
    setFormValues(WorkDataState || {});
  }, [WorkDataState]);

  const handleChange = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
    setInvalidFields((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newInvalidFields = {};
    let isValid = true;

    Object.keys(formValues).forEach((key) => {
      if (formValues[key] === "" && key !== "hprId" && key !== "reenterHprId") {
        newInvalidFields[key] = `Please Enter ${key}`;
        isValid = false;
      }
    });

    setInvalidFields(newInvalidFields);

    if (isValid) {
      setFormData(() => ({ ...formData, WorkData: { ...formValues } }));
    
      const body = {
        work: {...formValues,experience:Number(formValues.experience)},
      };
     
      try {
        await dispatch(
          editProfile({
            body,
            id: singleUser._id,
            userId: singleUser?.userId,
          })
        ).unwrap();

        setActiveTab(() => 3);
      } catch (error) {
        console.log("Profile submission error:", error);
        toast.error(
          error?.message || "An error occurred while saving the profile"
        );
      }
    }
  };

  return (
    <form
      className="pb-5 max-h-full px-3"
      style={{ maxHeight: "calc(100vh - 400px)" }}
      onSubmit={handleSubmit}
    >
      {WorkDataStateForm?.map((elm, index) => (
        <div key={index} className="pl-2 pb-4 border-b-2 border-slate-100">
          <div className="py-1 ">
            <h1 className="text-lg font-semibold text-gray-800">
              {elm.heading}
            </h1>
            <p className="text-sm text-gray-500 opacity-90">{elm.subHeading}</p>
          </div>
          <div className="px-4 mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-x-7 gap-y-4">
            {elm.forminput.map((elem) =>
              elem.id === "about" ? (
                <div key={elem.id} className="w-full col-span-3">
                  <Commontexfiled
                    value={formValues[elem.id] || ""}
                    onChange={(value) => handleChange(elem.id, value)}
                    label={elem.label}
                    placeholder={elem.placeholder}
                    isInvalid={invalidFields[elem.id]}
                    id={elem.id}
                    required={elem.required}
                  />
                </div>
              ) : (
                <div key={elem.id} className="w-full mb-2">
                  <CustomInput
                    key={elem.id}
                    type={elem.type}
                    label={elem.label}
                    id={elem.id}
                    placeholder={elem.placeholder}
                    value={formValues[elem.id] || ""}
                    isInvalid={invalidFields[elem.id]}
                    required={elem.required}
                    onchange={(e) => handleChange(elem.id, e.target.value)}
                  />
                </div>
              )
            )}
          </div>
        </div>
      ))}
      <div className="flex justify-between items-center mt-3 px-6">
        <CustomButton
          type="button"
          text="Previous"
          onClick={() => setActiveTab(1)}
        />
        <CustomButton
          type="submit"
          loading={isLoading}
          text={userType === "practitioner" ? "Next" : "Submit"}
          onClick={handleSubmit}
        />
      </div>
    </form>
  );
};

export default UserWork;
